import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mainbody modulewrap"
};
const _hoisted_2 = {
  class: "subwrap"
};
const _hoisted_3 = {
  class: "subconitem"
};
const _hoisted_4 = {
  class: "imgtitle"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 0,
  class: "subconitem6"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  key: 1,
  class: "subconitem7"
};
const _hoisted_10 = {
  class: "imgcover"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "subconbody"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = {
  key: 2,
  class: "subconitem8"
};
const _hoisted_15 = {
  class: "subconbox"
};
const _hoisted_16 = ["onMouseover"];
const _hoisted_17 = ["src"];
const _hoisted_18 = ["innerHTML"];
export default {
  __name: 'product',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const FFdata = reactive({
      alias: 'product',
      isLoad: false,
      listInfo: [],
      kindInfo: {},
      appIndex: 0,
      topTitle: ''
    });
    const getData = () => {
      proxy.$common.fetch({
        'act': 'sei_info',
        'exts': 'alias=' + FFdata.alias,
        msg: ''
      }, res => {
        proxy.$common.each(res.infodata, item => {
          item.sublist = proxy.$common.basic.FFfilter(res.infodatasub, 'pid', item.id);
        });
        FFdata.listInfo = res.infodata;
        FFdata.kindInfo = res.infodatakind;
        FFdata.isLoad = true;
        FFdata.topTitle = res.infodatakind.title;
      });
      proxy.$store.SET_NAVALIAS(FFdata.alias);
    };
    const chApp = v => {
      FFdata.appIndex = v;
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _directive_title = _resolveDirective("title");
      return _unref(FFdata).isLoad ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).listInfo, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "subconlist",
          key: item.id
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
          src: item.cover
        }, null, 8, _hoisted_5)])]), index == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sublist, item2 => {
          return _openBlock(), _createElementBlock("dl", {
            key: item2.id
          }, [_createElementVNode("dt", null, [_createElementVNode("img", {
            src: item2.cover
          }, null, 8, _hoisted_7)]), _createElementVNode("dd", {
            innerHTML: item2.content
          }, null, 8, _hoisted_8)]);
        }), 128))])) : index == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sublist, item2 => {
          return _openBlock(), _createElementBlock("div", {
            class: "subconbox",
            key: item2.id
          }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
            src: item2.cover
          }, null, 8, _hoisted_11)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("dl", null, [_createElementVNode("dt", null, _toDisplayString(_ctx.$common.langInfo(item2.title, item2.title_en)), 1), _createElementVNode("dd", {
            innerHTML: item2.content
          }, null, 8, _hoisted_13)])])]);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sublist, (item2, index2) => {
          return _openBlock(), _createElementBlock("div", {
            class: "imgcover",
            key: item2.id,
            onMouseover: $event => chApp(index2)
          }, [_createElementVNode("img", {
            src: item2.cover
          }, null, 8, _hoisted_17), _createElementVNode("div", {
            class: _normalizeClass(['imgcovertitle', index2 == _unref(FFdata).appIndex ? 'cs' : ''])
          }, _toDisplayString(_ctx.$common.langInfo(item2.title, item2.title_en)), 3)], 40, _hoisted_16);
        }), 128))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sublist, (item2, index2) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "subconbox2",
            key: item2.id
          }, [_createElementVNode("dl", null, [_createElementVNode("dt", null, _toDisplayString(_ctx.$common.langInfo(item2.title, item2.title_en)), 1), _createElementVNode("dd", {
            innerHTML: item2.content
          }, null, 8, _hoisted_18)])])), [[_vShow, index2 == _unref(FFdata).appIndex]]);
        }), 128))]))]);
      }), 128))])])), [[_directive_title, _unref(FFdata).topTitle]]) : _createCommentVNode("", true);
    };
  }
};